$(function () {
  $('.tab-career-item').on('click', function () {
    let index = $('.tab-career-item').index(this);

    $('.tab-career-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.tab-career-content').removeClass('is-show');
    $('.tab-career-content').eq(index).addClass('is-show');
  });
  $('.tab-education-item').on('click', function () {
    let index = $('.tab-education-item').index(this);

    $('.tab-education-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.tab-education-content').removeClass('is-show');
    $('.tab-education-content').eq(index).addClass('is-show');
  });
  $('.tab-recruitments-item').on('click', function () {
    let index = $('.tab-recruitments-item').index(this);

    $('.tab-recruitments-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.tab-recruitments-content').removeClass('is-show');
    $('.tab-recruitments-content').eq(index).addClass('is-show');
  });
  $('.tab-environment-item').on('click', function () {
    let index = $('.tab-environment-item').index(this);

    $('.tab-environment-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.tab-environment-content').removeClass('is-show');
    $('.tab-environment-content').eq(index).addClass('is-show');
  });
  $('.subtab-seminar-item').on('click', function () {
    let index = $('.subtab-seminar-item').index(this);

    $('.subtab-seminar-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.subtab-seminar-content').removeClass('is-show');
    $('.subtab-seminar-content').eq(index).addClass('is-show');
  });
  $('.tab-seminar-item').on('click', function () {
    let index = $('.tab-seminar-item').index(this);

    $('.tab-seminar-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.tab-seminar-content').removeClass('is-show');
    $('.tab-seminar-content').eq(index).addClass('is-show');
  });
  $('.subtab-seminar-item').on('click', function () {
    let index = $('.subtab-seminar-item').index(this);

    $('.subtab-seminar-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.subtab-seminar-content').removeClass('is-show');
    $('.subtab-seminar-content').eq(index).addClass('is-show');
  });
  $('.subtab-internship-item').on('click', function () {
    let index = $('.subtab-internship-item').index(this);

    $('.subtab-internship-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.subtab-internship-content').removeClass('is-show');
    $('.subtab-internship-content').eq(index).addClass('is-show');
  });

});
